"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7630],{

/***/ 29803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ lastPurchasesQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query lastOrdersPurchasesQuery {\n    lastOrdersPurchases {\n      product {\n        id\n        uuid\n        name\n        tradename\n        makerBrand\n        slug\n        concentration\n        imagesUrl\n        laboratory\n        activePrinciple\n        unit\n        quantity\n        thumbnailUrl\n        price\n        discount {\n          price\n          type\n          stockRestriction\n          dateRestriction\n          listPrice\n        }\n        prescriptionType\n        availability {\n          status\n          statusWithoutStock\n          stock\n          discountStock\n        }\n        categories {\n          id\n          name\n        }\n        isCheapestActivePrinciple\n      }\n      orderId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPurchasesQuery = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 65165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ previousOrdersQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: previousOrders.ts
 * Project: meki
 * File Created: Tuesday, 16th November 2021 6:29:07 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Wednesday, 8th February 2023 4:04:29 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ",
        "($params: GetOrdersParams) {\n    orders(params: $params) {\n      nodes {\n        id\n        uuid\n        orderGroupId\n        onDemand\n        address {\n          name\n          street\n          streetNumber\n        }\n        status\n        deliveryCost\n        deliveryDate\n        deliveryType\n        paidAt\n        payments {\n          id\n          amount\n          paymentMethodType\n          status\n        }\n        orderDetails(allowZero: true) {\n          id\n          uuid\n          price\n          quantity\n          requestedQuantity\n          returnedQuantity\n          product {\n            id\n            name\n            quantity\n            concentration\n          }\n        }\n        orderInsurance {\n          id\n        }\n      }\n      pageInfo {\n        hasNextPage\n        pageNumber\n        hasPreviousPage\n        totalPages\n      }\n      totalCount\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var previousOrdersQuery = function(name) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), name);
};


/***/ }),

/***/ 98251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ PaymentMethodDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/styles/PaymentsOptions.styles.ts
var PaymentsOptions_styles = __webpack_require__(4654);
// EXTERNAL MODULE: ./src/screens/checkout/paymentConfirm/styles/ProductsList.styles.ts
var ProductsList_styles = __webpack_require__(23793);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/CardIcon.tsx
var CardIcon = __webpack_require__(51798);
// EXTERNAL MODULE: ./src/interfaces/index.ts + 2 modules
var interfaces = __webpack_require__(95790);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/helpers/PaymentMethodTexts.tsx

var PaymentMethodTexts = function(param) {
    var paymentMethod = param.paymentMethod, creditsUsed = param.creditsUsed;
    var ref, ref1;
    var cardInfo = (0,interfaces/* isPaymentMethodDataOneClick */.KR)(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.data) ? "".concat(paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref = paymentMethod.data) === null || ref === void 0 ? void 0 : ref.creditCardType, " ").concat(paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref1 = paymentMethod.data) === null || ref1 === void 0 ? void 0 : ref1.last4CardDigits.toString().replace(/XXXXXXXXXXXX/g, "•••• ")) : "";
    switch(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type){
        case "ONE_CLICK":
            return {
                title: cardInfo,
                description: "Webpay OneClick"
            };
        case "FINTOC":
            return {
                title: "Directo con tu banco",
                description: "sin salir de la p\xe1gina"
            };
        case "MEKI_CREDIT":
            return {
                title: "Cr\xe9ditos Meki",
                description: creditsUsed
            };
        case "BANCO_ESTADO":
            return {
                title: "Banco Estado",
                description: "Compraqu\xed"
            };
        case "INSURANCE":
            return {
                title: "Seguro",
                description: ""
            };
        default:
            return {
                title: "",
                description: ""
            };
    }
};

// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/PaymentMethodDetails.tsx







var paymentMethodTypes = {
    CASH: "Efectivo",
    CARD: "Tarjeta",
    TRANSFER: "Transferencia",
    CARD_CASH: "Tarjeta + Efectivo"
};
function PaymentMethodDetails(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var paymentMethod = props.paymentMethod, creditsUsed = props.creditsUsed, hideHeader = props.hideHeader, hideInstallments = props.hideInstallments;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isAssistantUser = userCan("MANAGE_USER");
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var order = (0,useOrderState/* useOrderState */.h)().order;
    var localPaymentMethod = order === null || order === void 0 ? void 0 : (ref = order.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.localVendor) === null || ref1 === void 0 ? void 0 : ref1.paymentMethod;
    var assistantPaymentMethod = order === null || order === void 0 ? void 0 : (ref2 = order.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.assistantVendor) === null || ref3 === void 0 ? void 0 : ref3.paymentMethod;
    var isClient = !(isLocalVendor && localPaymentMethod) && !(isAssistantUser && assistantPaymentMethod);
    var paymentMethodText = PaymentMethodTexts({
        paymentMethod: paymentMethod,
        creditsUsed: creditsUsed
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsList_styles/* RootDiv */.of, {
        children: [
            !hideHeader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsList_styles/* TitleTypography */.dP, {
                        children: " M\xe9todo de pago seleccionado "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsList_styles/* DivisionLine */.O3, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsList_styles/* PaymentMethodItem */.yY, {
                children: [
                    (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === "FINTOC" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                        creditCardType: "Fintoc"
                    }) : (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === "BANCO_ESTADO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                        creditCardType: "BancoEstado"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                        creditCardType: paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref4 = paymentMethod.data) === null || ref4 === void 0 ? void 0 : ref4.creditCardType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                        children: [
                            isClient && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                        children: paymentMethodText === null || paymentMethodText === void 0 ? void 0 : paymentMethodText.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                        light: true,
                                        children: paymentMethodText === null || paymentMethodText === void 0 ? void 0 : paymentMethodText.description
                                    })
                                ]
                            }),
                            isLocalVendor && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                        children: "Venta en local"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                        light: true,
                                        children: paymentMethodTypes[localPaymentMethod]
                                    })
                                ]
                            }),
                            isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                        children: "Pago por asistente"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                        light: true,
                                        children: paymentMethodTypes[assistantPaymentMethod]
                                    })
                                ]
                            }),
                            !hideInstallments && (order === null || order === void 0 ? void 0 : (ref5 = order.metadata) === null || ref5 === void 0 ? void 0 : ref5.installments) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* InstallmentsText */.PM, {
                                    children: [
                                        order === null || order === void 0 ? void 0 : (ref6 = order.metadata) === null || ref6 === void 0 ? void 0 : ref6.installments,
                                        " cuotas"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 82830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ProductsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_ProductsList_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23793);
/* harmony import */ var _screens_checkout_paymentSuccess_components_Item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39566);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8881);
/* harmony import */ var _hooks_usePermissions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18782);







function ProductsList(props) {
    var isDelivery = props.isDelivery, orders = props.orders, insuranceInfo = props.insuranceInfo;
    var userCan = (0,_hooks_usePermissions__WEBPACK_IMPORTED_MODULE_5__/* .usePermissions */ .T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var findDetailsWithInsurance = function(orderDetails) {
        return orderDetails.filter(function(detail) {
            return detail.insurance;
        });
    };
    var findDetailsWithoutInsurance = function(orderDetails) {
        return orderDetails.filter(function(detail) {
            return !detail.insurance;
        });
    };
    var userSelectedInsurance = insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.insuranceId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_ProductsList_styles__WEBPACK_IMPORTED_MODULE_2__/* .RootDiv */ .of, {
        children: orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    isLocalVendor ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_ProductsList_styles__WEBPACK_IMPORTED_MODULE_2__/* .SubTitleTypography */ .aL, {
                        children: "Venta en Local"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles_ProductsList_styles__WEBPACK_IMPORTED_MODULE_2__/* .SubTitleTypography */ .aL, {
                        children: [
                            isDelivery ? "Entrega: " : "Retiro: ",
                            "".concat((0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .getWeekdayName */ .ng)(order.deliveryDate.replace(/-/g, "/")), " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .extractShortDate */ .Pb)((0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .withoutTimezone */ .ej)(order.deliveryDate.split(",")[0])))
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_ProductsList_styles__WEBPACK_IMPORTED_MODULE_2__/* .DivisionLine */ .O3, {}),
                    findDetailsWithInsurance(order === null || order === void 0 ? void 0 : order.orderDetails).length > 0 && userSelectedInsurance && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_ProductsList_styles__WEBPACK_IMPORTED_MODULE_2__/* .SubTitleTypography */ .aL, {
                                children: "Productos con cobertura de seguro"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_ProductsList_styles__WEBPACK_IMPORTED_MODULE_2__/* .DivisionLine */ .O3, {})
                        ]
                    }),
                    findDetailsWithInsurance(order === null || order === void 0 ? void 0 : order.orderDetails).map(function(detail) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_checkout_paymentSuccess_components_Item__WEBPACK_IMPORTED_MODULE_3__/* .Item */ .c, {
                            product: detail.product,
                            price: detail.price,
                            quantity: detail.quantity,
                            loading: false,
                            insurance: detail.insurance,
                            type: detail.type ? String(detail.type) : null,
                            listPrice: Number(detail.listPrice)
                        }, "".concat(detail.id, "_").concat(detail.price, "_").concat(detail.quantity));
                    }),
                    findDetailsWithoutInsurance(order === null || order === void 0 ? void 0 : order.orderDetails).length > 0 && userSelectedInsurance && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_ProductsList_styles__WEBPACK_IMPORTED_MODULE_2__/* .SubTitleTypography */ .aL, {
                                children: "Productos sin cobertura de seguro"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_ProductsList_styles__WEBPACK_IMPORTED_MODULE_2__/* .DivisionLine */ .O3, {})
                        ]
                    }),
                    findDetailsWithoutInsurance(order === null || order === void 0 ? void 0 : order.orderDetails).map(function(detail) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_checkout_paymentSuccess_components_Item__WEBPACK_IMPORTED_MODULE_3__/* .Item */ .c, {
                            product: detail.product,
                            price: detail.price,
                            quantity: detail.quantity,
                            loading: false,
                            insurance: detail.insurance,
                            type: detail.type ? String(detail.type) : null,
                            listPrice: Number(detail.listPrice)
                        }, "".concat(detail.id, "_").concat(detail.price, "_").concat(detail.quantity));
                    })
                ]
            }, order.id);
        })
    });
}


/***/ }),

/***/ 17630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PaymentConfirm": function() { return /* binding */ PaymentConfirm; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(98449);
// EXTERNAL MODULE: ./src/components/ModalContent.tsx + 1 modules
var ModalContent = __webpack_require__(84726);
// EXTERNAL MODULE: ./src/components/ModalHeader.tsx
var ModalHeader = __webpack_require__(69051);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ../../node_modules/@fintoc/fintoc-js/build/module/lib/core.js + 1 modules
var core = __webpack_require__(12534);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./src/hooks/useFacebookPixel.ts
var useFacebookPixel = __webpack_require__(14931);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ./src/hooks/useModalRouter.ts
var useModalRouter = __webpack_require__(9006);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/usePendingPrescriptions.ts + 1 modules
var usePendingPrescriptions = __webpack_require__(3618);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/checkout/mutations/separateOrderByInsurance.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SeparateOrderDetailsByInsurance(\n    $params: SeparateOrderDetailsByInsuranceParams\n  ) {\n    separateOrderDetailsByInsurance(params: $params) {\n      deliveryDate\n      deliveryType\n      deliveryCost\n      orderDetails {\n        quantity\n        insurance {\n          unitReimbursement\n          unitCopay\n          unitDeductible\n        }\n        type\n        listPrice\n        product {\n          id\n          name\n          imagesUrl\n          activePrinciple\n          concentration\n          unit\n          prescriptionType\n          quantity\n          format\n          price\n          container\n          containerQuantity\n          laboratory\n          availability {\n            stock\n            statusWithoutStock\n            status\n          }\n          discount {\n            type\n            price\n            listPrice\n          }\n        }\n        price\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SeparateOrderDetailsByInsurance = function() {
    return (0,lib/* gql */.Ps)(_templateObject());
};

// EXTERNAL MODULE: ./src/queries/checkout/queries/detail.ts
var detail = __webpack_require__(45482);
// EXTERNAL MODULE: ./src/queries/checkout/queries/finalSummary.ts
var finalSummary = __webpack_require__(70041);
// EXTERNAL MODULE: ./src/queries/checkout/queries/paymentMethod.ts
var queries_paymentMethod = __webpack_require__(66003);
// EXTERNAL MODULE: ./src/queries/order/queries/nextOrders.ts
var nextOrders = __webpack_require__(37599);
// EXTERNAL MODULE: ./src/queries/order/queries/getLastOrdersPurchases.tsx
var getLastOrdersPurchases = __webpack_require__(29803);
// EXTERNAL MODULE: ./src/queries/order/queries/previousOrders.ts
var queries_previousOrders = __webpack_require__(65165);
;// CONCATENATED MODULE: ./src/queries/payment/mutations/payOrder.tsx
/*
 * File: payOrder.tsx
 * Project: meki
 * File Created: Monday, 9th November 2020 10:31:19 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Wednesday, 5th October 2022 3:30:13 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function payOrder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation ",
        "($params: PayOrderParams!){\n  payOrder(params: $params) {\n    id\n    uuid\n    status\n    orderGroupId\n    address {\n      id\n      name\n      street\n      streetNumber\n      commune\n    }\n  }\n}\n"
    ]);
    payOrder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PayOrder = function(name) {
    return (0,lib/* gql */.Ps)(payOrder_templateObject(), name);
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/payOrderFintoc.tsx

function payOrderFintoc_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PayOrderFintoc($params: PayOrderFintocParams!) {\n    payOrderFintoc(params: $params) {\n      fintocToken\n      uuid\n      orderGroupId\n    }\n  }\n"
    ]);
    payOrderFintoc_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PayOrderFintoc = function() {
    return (0,lib/* gql */.Ps)(payOrderFintoc_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/cancelFintocPayment.tsx
/*
 * File: payOrder.tsx
 * Project: meki
 * File Created: Monday, 9th November 2020 10:31:19 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Wednesday, 5th October 2022 3:30:13 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function cancelFintocPayment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelFintocPayment($params: CancelFintocPaymentParams!) {\n    cancelFintocPayment(params: $params) {\n      id\n      deliveryType\n      deliveryCost\n      totalCost\n      mekiCreditsUsed\n      onDemand\n      payments {\n        id\n        status\n        amount\n        paymentMethodType\n      }\n      address {\n        id\n        uuid\n        apartment\n        commune\n        street\n        streetNumber\n        details\n        name\n      }\n      paymentMethod {\n        id\n        uuid\n        type\n        data\n      }\n      status\n      orderGroupId\n      paidAt\n      orderDetails {\n        id\n        quantity\n        price\n        product {\n          id\n          name\n          concentration\n          quantity\n          unit\n          format\n          imagesUrl\n          display\n          price\n          prescriptionType\n          metadata {\n            refrigerated\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    cancelFintocPayment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CancelFintocPayment = function() {
    return (0,lib/* gql */.Ps)(cancelFintocPayment_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/cancelPayOrderLocal.tsx

function cancelPayOrderLocal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelPayOrderLocal($params: CancelPayOrderLocalParams!) {\n    cancelPayOrderLocal(params: $params) {\n      status\n      id\n    }\n  }\n"
    ]);
    cancelPayOrderLocal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CancelPayOrderLocal = function() {
    return (0,lib/* gql */.Ps)(cancelPayOrderLocal_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/confirmLocalPayment.tsx

function confirmLocalPayment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ConfirmLocalPayment($params: ConfirmLocalPaymentParams!) {\n    confirmLocalPayment(params: $params) {\n      id\n      status\n      orderGroupId\n      uuid\n    }\n  }\n"
    ]);
    confirmLocalPayment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ConfirmLocalPayment = function() {
    return (0,lib/* gql */.Ps)(confirmLocalPayment_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/declarePayOrder.tsx

function declarePayOrder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeclarePayOrder($params: DeclarePayOrderParams!) {\n    declarePayOrder(params: $params) {\n      id\n      uuid\n      status\n      orderGroupId\n      address {\n        id\n        name\n        street\n        streetNumber\n        commune\n      }\n    }\n  }\n"
    ]);
    declarePayOrder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var DeclarePayOrder = function() {
    return (0,lib/* gql */.Ps)(declarePayOrder_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/cancelBancoEstadoPayment.tsx

function cancelBancoEstadoPayment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelBancoEstadoPayment($params: CancelBancoEstadoPaymentParams!) {\n    cancelBancoEstadoPayment(params: $params) {\n      id\n      deliveryType\n      deliveryCost\n      totalCost\n      mekiCreditsUsed\n      onDemand\n      payments {\n        id\n        status\n        amount\n        paymentMethodType\n      }\n      address {\n        id\n        uuid\n        apartment\n        commune\n        street\n        streetNumber\n        details\n        name\n      }\n      paymentMethod {\n        id\n        uuid\n        type\n        data\n      }\n      status\n      orderGroupId\n      paidAt\n      orderDetails {\n        id\n        quantity\n        price\n        product {\n          id\n          name\n          concentration\n          quantity\n          unit\n          format\n          imagesUrl\n          display\n          price\n          prescriptionType\n          metadata {\n            refrigerated\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    cancelBancoEstadoPayment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CancelBancoEstadoPayment = function() {
    return (0,lib/* gql */.Ps)(cancelBancoEstadoPayment_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/bancoEstadoPayment.tsx

function bancoEstadoPayment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation BancoEstadoPayment($params: BancoEstadoPaymentParams!) {\n    bancoEstadoPayment(params: $params) {\n      urlCompraqui\n      uuid\n      orderGroupId\n    }\n  }\n"
    ]);
    bancoEstadoPayment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BancoEstadoPayment = function() {
    return (0,lib/* gql */.Ps)(bancoEstadoPayment_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/verifyBancoEstadoJwt.tsx

function verifyBancoEstadoJwt_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation VerifyBancoEstadoJwt($params: VerifyBancoEstadoJwtParams!) {\n    verifyBancoEstadoJwt(params: $params) {\n      uuid\n      orders {\n        id\n        uuid\n        status\n        orderGroupId\n        address {\n          id\n          name\n          street\n          streetNumber\n          commune\n        }\n      }\n      totalPrice\n      deliveryPrice\n    }\n  }\n"
    ]);
    verifyBancoEstadoJwt_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var VerifyBancoEstadoJwt = function() {
    return (0,lib/* gql */.Ps)(verifyBancoEstadoJwt_templateObject());
};

// EXTERNAL MODULE: ./src/queries/user/queries/currentUserCredits.tsx
var currentUserCredits = __webpack_require__(93231);
// EXTERNAL MODULE: ./src/services/openreplay.ts
var openreplay = __webpack_require__(92268);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/index.tsx + 17 modules
var components = __webpack_require__(69221);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/PayButton.hooks.ts
var PayButton_hooks = __webpack_require__(18211);
;// CONCATENATED MODULE: ./src/queries/order/queries/pendingPrescriptions.ts
/*
 * File: currentOrderWithPrescriptions.ts
 * Project: meki
 * File Created: Thursday, 15th July 2021 11:49:41 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Wednesday, 19th July 2023 1:10:36 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function pendingPrescriptions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PendingPrescriptions {\n    pendingPrescriptions {\n      id\n      uuid\n      url\n      createdAt\n    }\n  }\n"
    ]);
    pendingPrescriptions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pendingPrescriptions = function() {
    return (0,lib/* gql */.Ps)(pendingPrescriptions_templateObject());
};

// EXTERNAL MODULE: ./src/screens/prescription/components/UploadImage.tsx + 2 modules
var UploadImage = __webpack_require__(55823);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/PendingPrescriptions.tsx




function PendingPrescriptions(props) {
    var title = props.title, hasInsurance = props.hasInsurance, error = props.error, setError = props.setError;
    var ref = (0,useQuery/* useQuery */.a)(pendingPrescriptions(), {
        fetchPolicy: "cache-and-network"
    }), prescriptionsData = ref.data;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* UploadImage */.z, {
            title: title,
            insuranceText: hasInsurance,
            confirmText: true,
            emptyError: error,
            setError: setError,
            data: {
                currentUserInfo: null,
                pendingPrescriptions: (ref1 = prescriptionsData === null || prescriptionsData === void 0 ? void 0 : prescriptionsData.pendingPrescriptions) !== null && ref1 !== void 0 ? ref1 : []
            }
        })
    });
}

// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/localPaymentOptionsStore.tsx
var localPaymentOptionsStore = __webpack_require__(57500);
// EXTERNAL MODULE: ./src/screens/checkout/utils/getDeliveryCosts.ts
var getDeliveryCosts = __webpack_require__(4999);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/styles/Resume.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    margin: "-16px 0px 0px 0px",
    justifySelf: "center",
    padding: "50px 30px 0px 30px",
    borderBottom: "1px solid #EAEAEA",
    width: "100%"
});
var ContextTextContianer = (0,styled/* default */.Z)("div")({
    display: "flex",
    justifyContent: "space-between"
});
var ContentText = (0,styled/* default */.Z)(Typography/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "light" && prop !== "bold" && prop !== "highlight" && prop !== "lineThrough" && prop !== "float" && prop !== "marginRight";
    }
})(function(param) {
    var light = param.light, bold = param.bold, highlight = param.highlight, lineThrough = param.lineThrough, float = param.float, marginRight = param.marginRight;
    return {
        fontFamily: "Poppins",
        fontWeight: light ? "300" : bold ? "500" : "400",
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: highlight ? "#731EFF" : "#414046",
        textDecoration: lineThrough ? "line-through" : "none",
        float: float,
        marginRight: marginRight
    };
});
var LineContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    justifyContent: "center",
    margin: "6px 0px 6px 0px"
});
var GapContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "4px"
});
var TotalAmountContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    justifyContent: "space-between",
    margin: "16px 0px 16px 0px"
});
var PayButtonContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    justifyContent: "center",
    marginTop: "12px",
    marginBottom: "12px",
    cursor: "pointer",
    paddingBottom: "0px",
    flexDirection: "column"
});


// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/styles/PaymentFooter.styles.ts
var PaymentFooter_styles = __webpack_require__(56837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styles_styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(70918);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(75158);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/styles/PayButton.styles.ts



var PaperContainer = (0,styles_styled/* default */.ZP)(Paper/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        objectFit: "contain",
        display: "flex",
        alignItems: "center",
        color: theme.palette.primary.main,
        justifyContent: "space-between",
        padding: "11 14 11 14"
    };
});
var CheckBoxStyled = (0,styles_styled/* default */.ZP)(Checkbox/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "focus";
    }
})(function(param) {
    var theme = param.theme, focus = param.focus;
    return (0,_object_spread/* default */.Z)({}, focus && {
        color: theme.palette.error.main
    });
});
var ATagStyled = (0,styles_styled/* default */.ZP)("a")(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.primary.main
    };
});
var SpanStyled = (0,styles_styled/* default */.ZP)("span")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "white"
});
var CircularLoaderDiv = (0,styles_styled/* default */.ZP)(CircularProgress/* default */.Z)({
    textAlign: "center",
    margin: 26
});
var ButtonDiv = (0,styles_styled/* default */.ZP)("div")({
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    width: "100%",
    zIndex: 2,
    margin: "12px 0px 12px 0px"
});
var LocalTypographyButton = (0,styles_styled/* default */.ZP)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px"
});
var LocalCancelButton = (0,styles_styled/* default */.ZP)("button")({
    borderRadius: "100px",
    padding: "8px 60px",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
    color: "#414046",
    backgroundColor: "transparent",
    border: "none",
    marginBottom: "10px"
});


// EXTERNAL MODULE: ./src/components/ModalButton.styles.ts
var ModalButton_styles = __webpack_require__(37989);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/PayButton.tsx




function PayButton(props) {
    var handleNext = props.handleNext, text = props.text, form = props.form, type = props.type, disabled = props.disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButton_styles/* Button */.zx, {
            onClick: handleNext,
            form: form,
            type: type,
            disabled: disabled,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButton_styles/* TypographyButton */.yU, {
                children: text
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(64529);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/zustand/currentOrderStore.tsx

var currentOrderLoadingStore = (0,esm/* create */.Ue)()(function(set) {
    return {
        loadingCurrentOrder: false,
        setLoadingCurrentOrder: function(to) {
            set({
                loadingCurrentOrder: to
            });
        }
    };
});
var useCurrentOrderLoadingStore = function() {
    return currentOrderLoadingStore(function(state) {
        return {
            loadingCurrentOrder: state.loadingCurrentOrder,
            setLoadingCurrentOrder: state.setLoadingCurrentOrder
        };
    });
};

;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/Resume.tsx










function Resume(props) {
    var totalCost = props.totalCost, shippingCost = props.shippingCost, totalFinal = props.totalFinal, handlePay = props.handlePay, paymentMethod = props.paymentMethod, handleCancelPayOrderLocal = props.handleCancelPayOrderLocal, oldShippingCost = props.oldShippingCost;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isAssistantUser = userCan("MANAGE_USER");
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var ref = (0,useAuth/* useAuth */.a)(), user = ref.appUser;
    var order = (0,useOrderState/* useOrderState */.h)().order;
    var orderMetadata = order === null || order === void 0 ? void 0 : order.metadata;
    var ref1;
    var userMekiCredits = (ref1 = user === null || user === void 0 ? void 0 : user.credits) !== null && ref1 !== void 0 ? ref1 : 0;
    var ref2 = orderMetadata || {}, useMekiCredits = ref2.useMekiCredits, installments = ref2.installments, insuranceInfo = ref2.insuranceInfo;
    var totalReimbursement = (insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.totalReimbursement) || 0;
    var totalDeductible = (insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.totalDeductible) || 0;
    var claimId = (insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.claimId) || null;
    var isPickUp = (order === null || order === void 0 ? void 0 : order.deliveryType) == "PICK_UP" || false;
    var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: ""
    });
    var subTotal = totalCost - shippingCost;
    var totalCopay = ((insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.reimbursedProducts) || []).reduce(function(acc, product) {
        return acc + product.unitCopay;
    }, 0);
    var sellDeductible = totalCopay - totalDeductible;
    var loadingCurrentOrder = useCurrentOrderLoadingStore().loadingCurrentOrder;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GapContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                bold: true,
                                children: "Subtotal productos"
                            }),
                            loadingCurrentOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter_styles/* SkeletonTotalPriceText */.Fh, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                bold: true,
                                children: currencyFormatter.format(subTotal)
                            })
                        ]
                    }),
                    Boolean(claimId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter_styles/* HorizontalLine */.fu, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        light: true,
                                        children: "Reembolso p\xf3liza"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        light: true,
                                        children: currencyFormatter.format(totalReimbursement + totalDeductible) || "$0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        light: true,
                                        children: "Deducible p\xf3liza"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        light: true,
                                        children: currencyFormatter.format(totalDeductible) || "$0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        light: true,
                                        children: "Aporte seguro"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        light: true,
                                        children: currencyFormatter.format(totalReimbursement) || "$0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        light: true,
                                        children: "Deducible venta"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        light: true,
                                        children: currencyFormatter.format(sellDeductible) || "$0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        bold: true,
                                        children: "Valor a pagar productos"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        bold: true,
                                        children: currencyFormatter.format(subTotal - totalReimbursement) || "$0"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LineContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter_styles/* HorizontalLine */.fu, {})
                    }),
                    !isPickUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                light: true,
                                children: "Despacho"
                            }),
                            loadingCurrentOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter_styles/* SkeletonTotalPriceText */.Fh, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentText, {
                                light: !oldShippingCost,
                                highlight: oldShippingCost > 0,
                                bold: oldShippingCost > 0,
                                children: [
                                    oldShippingCost ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                        light: true,
                                        highlight: false,
                                        lineThrough: true,
                                        float: "left",
                                        marginRight: 6,
                                        children: currencyFormatter.format(oldShippingCost)
                                    }) : null,
                                    shippingCost > 0 ? currencyFormatter.format(shippingCost) : "Gratis"
                                ]
                            })
                        ]
                    }),
                    !isLocalVendor && useMekiCredits && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                light: true,
                                children: "Cr\xe9ditos Meki"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentText, {
                                children: [
                                    "-",
                                    currencyFormatter.format(Math.min(totalCost, userMekiCredits)) || "$0"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                bold: true,
                                children: "Total a pagar"
                            }),
                            loadingCurrentOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter_styles/* SkeletonTotalPriceText */.Fh, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                bold: true,
                                children: totalFinal == 0 ? "$0" : currencyFormatter.format(totalFinal)
                            })
                        ]
                    })
                ]
            }),
            installments > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LineContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter_styles/* HorizontalLine */.fu, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContextTextContianer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                                bold: true,
                                children: "N\xba de cuotas"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentText, {
                                bold: true,
                                children: [
                                    installments,
                                    " cuotas"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayButton, {
                    handleNext: handlePay,
                    text: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "ONE_CLICK" || isLocalVendor || isAssistantUser || (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "MEKI_CREDIT" || (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "INSURANCE" ? "Confirmar compra" : "Ir a pagar"
                })
            }),
            isLocalVendor && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCancelButton, {
                onClick: handleCancelPayOrderLocal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalTypographyButton, {
                    children: "Cancelar pago"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/index.ts



;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/styles/DeliveryDetails.styles.ts


var DeliveryDetails_styles_RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    border: "1px solid #EAEAEA",
    borderRadius: "10px"
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: 600,
    color: "#414046",
    lineHeight: "24px",
    textAlign: "left",
    margin: "12px 0px 12px 12px"
});
var DirectionContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    gap: "5px",
    marginTop: "10px"
});
var PaddingContainer = (0,styled/* default */.Z)("div")({
    padding: "12px 15px"
});
var InformationTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "#757475",
    "> span": {
        fontWeight: 500,
        color: "#414046",
        marginRight: "5px"
    }
});
var InlineContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    gap: "5px"
});


// EXTERNAL MODULE: ./src/screens/checkout/paymentConfirm/styles/ProductsList.styles.ts
var ProductsList_styles = __webpack_require__(23793);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/DeliveryDetails.tsx








function DeliveryDetails(props) {
    var ref;
    var deliveryDatesAndProductsAmount = props.deliveryDatesAndProductsAmount, address = props.address, deliveryType = props.deliveryType;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var loadingCurrentOrder = useCurrentOrderLoadingStore().loadingCurrentOrder;
    var firstDate = (ref = (deliveryDatesAndProductsAmount || [])[0]) === null || ref === void 0 ? void 0 : ref.date.replace(/-/g, "/");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryDetails_styles_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleTypography, {
                children: [
                    "Detalle ",
                    deliveryType == "PICK_UP" ? "retiro" : "entrega"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsList_styles/* DivisionLine */.O3, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaddingContainer, {
                children: [
                    loadingCurrentOrder || (deliveryDatesAndProductsAmount === null || deliveryDatesAndProductsAmount === void 0 ? void 0 : deliveryDatesAndProductsAmount.length) == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationTypography, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: deliveryType == "PICK_UP" ? "Retiro:" : "Entrega:"
                                }),
                                loadingCurrentOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter_styles/* SkeletonTotalPriceText */.Fh, {}),
                                deliveryDatesAndProductsAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: loadingCurrentOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter_styles/* SkeletonTotalPriceText */.Fh, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            (0,utils/* getWeekdayName */.ng)(firstDate),
                                            " ",
                                            (0,utils/* extractShortDate */.Pb)((0,utils/* withoutTimezone */.ej)(new Date(firstDate)))
                                        ]
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationTypography, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: deliveryType == "PICK_UP" ? "Retiros" : "Entregas"
                                })
                            }),
                            deliveryDatesAndProductsAmount === null || deliveryDatesAndProductsAmount === void 0 ? void 0 : deliveryDatesAndProductsAmount.map(function(values, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationTypography, {
                                    children: [
                                        "\xb7 ",
                                        values.productAmount,
                                        " producto",
                                        values.productAmount > 1 && "s",
                                        " el",
                                        " ".concat((0,utils/* getWeekdayName */.ng)(values.date.replace(/-/g, "/")), " ").concat((0,utils/* extractShortDate */.Pb)((0,utils/* withoutTimezone */.ej)(new Date(values.date.replace(/-/g, "/")))))
                                    ]
                                }, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectionContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationTypography, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Direcci\xf3n:"
                                }),
                                loadingCurrentOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter_styles/* SkeletonTotalPriceText */.Fh, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: deliveryType == "PICK_UP" || isLocalVendor ? "Av. El Salto 4001, Local 8, Huechuraba" : (0,utils/* formatAddress */.Tg)(address)
                                })
                            ]
                        })
                    }),
                    deliveryType == "PICK_UP" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectionContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationTypography, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Horario de atenci\xf3n: "
                                }),
                                "Lunes a Viernes de 09:00 a 18:00 hrs"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/screens/checkout/paymentConfirm/components/ErrorModal.tsx + 1 modules
var ErrorModal = __webpack_require__(65257);
// EXTERNAL MODULE: ./src/screens/checkout/paymentConfirm/components/PaymentMethodDetails.tsx + 1 modules
var PaymentMethodDetails = __webpack_require__(98251);
// EXTERNAL MODULE: ./src/screens/checkout/paymentConfirm/components/ProductsList.tsx
var ProductsList = __webpack_require__(82830);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/styles.tsx


var EmailNotificationTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    color: "#2196F3",
    lineHeight: "24px",
    textAlign: "left",
    margin: "12px 0px 0px 0px"
});
var ErrorNotificationTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    color: "#F44336",
    lineHeight: "24px",
    textAlign: "left",
    margin: "12px 0px 0px 0px"
});
var AddPadding = (0,styled/* default */.Z)("div")({
    padding: "0px 12px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginTop: "12px"
});


// EXTERNAL MODULE: ./node_modules/react-device-detect/main.js
var main = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/index.tsx

















































function PaymentConfirm() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var nextRouter = (0,router.useRouter)();
    var modalRouter = (0,useModalRouter/* useModalRouter */.r)();
    var ref9 = (0,useOrderState/* useOrderState */.h)(), currentOrder = ref9.order, orderUuid = ref9.orderUuid, refetchOrder = ref9.refetch, loadingCurrentOrder = ref9.loadingCurrentOrder;
    var ref10 = (0,useAuth/* useAuth */.a)(), user = ref10.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var track = (0,useSegment/* useSegment */.K)().track;
    var trackIssue = (0,openreplay/* useOpenReplayTracking */.WK)().trackIssue;
    var trackPayment = (0,PayButton_hooks/* useTrackPayment */.w)();
    var trackFBEvent = (0,useFacebookPixel/* useFacebokPixelEvent */.o)().trackFBEvent;
    var ref11 = (0,react.useState)(false), payLoading = ref11[0], setPayLoading = ref11[1];
    var ref12 = (0,react.useState)(false), error = ref12[0], setError = ref12[1];
    var ref13 = (0,react.useState)(""), errorMessage = ref13[0], setErrorMessage = ref13[1];
    var ref14 = (0,react.useState)(true), registryError = ref14[0], setRegistryError = ref14[1];
    var ref15 = (0,react.useState)(false), prescriptionsError = ref15[0], setPrescriptionsError = ref15[1];
    var ref16 = (0,react.useState)(false), isFintocSuccess = ref16[0], setIsFintocSucess = ref16[1];
    var ref17 = (0,react.useState)(false), fintocError = ref17[0], setFintocError = ref17[1];
    var ref18 = (0,react.useState)(false), showCancelButton = ref18[0], setShowCancelButton = ref18[1];
    var ref19 = (0,react.useState)(false), notAllowedItemsError = ref19[0], setNotAllowedItemsError = ref19[1];
    var ref20 = (0,react.useState)(false), insuranceValidationError = ref20[0], setInsuranceValidationError = ref20[1];
    var closeFintocIntervalRef = (0,react.useRef)();
    var ref21 = (0,useMekiState/* useMekiState */.c)(), setInsuranceId = ref21.setInsuranceId, setInsuranceRut = ref21.setInsuranceRut;
    var setLoadingCurrentOrder = useCurrentOrderLoadingStore().setLoadingCurrentOrder;
    var ref22 = (0,usePendingPrescriptions/* usePendingPrescriptions */.h)(), requirePrescriptions = ref22.requirePrescriptions, requirePrescriptionUpload = ref22.requirePrescriptionUpload, pendingPrescriptions = ref22.pendingPrescriptions, associatedPrescriptions = ref22.associatedPrescriptions;
    var data = (0,useQuery/* useQuery */.a)((0,queries_paymentMethod/* getCheckoutPaymentMethod */.k)(), {
        variables: {
            params: {
                orderUuid: orderUuid
            }
        }
    }).data;
    var ref23 = (0,useQuery/* useQuery */.a)((0,detail/* OrderDeliveryOptions */.J)(), {
        variables: {
            params: {
                orderUuid: orderUuid
            }
        },
        fetchPolicy: isLocalVendor ? "cache-only" : "cache-and-network"
    }), tmp = ref23.data, orderDeliveryOptions = (tmp === void 0 ? {} : tmp).orderDeliveryOptions;
    var deliveryOption = orderDeliveryOptions === null || orderDeliveryOptions === void 0 ? void 0 : orderDeliveryOptions.find(function(item) {
        return item.dates.length === ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderGroupId) ? 2 : 1);
    });
    var ordersByDelivery = deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.orders;
    var ref24 = (0,react.useState)(ordersByDelivery), orders = ref24[0], setOrders = ref24[1];
    var ref25 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(SeparateOrderDetailsByInsurance()), 1), separateDetailsByInsurance = ref25[0];
    var ref26 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PayOrder("payOrderSummary"), {
        refetchQueries: [
            {
                query: (0,nextOrders/* getNextOrders */.t)()
            },
            {
                query: (0,queries_previousOrders/* previousOrdersQuery */.Q)("pedidos"),
                variables: {
                    params: {
                        pageNumber: 0
                    }
                }
            },
            {
                query: (0,getLastOrdersPurchases/* lastPurchasesQuery */.W)()
            },
            {
                query: (0,currentUserCredits/* currentUserCredits */.B)()
            }, 
        ]
    }), 1), payOrder = ref26[0];
    var ref27 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PayOrderFintoc()), 1), payOrderFintoc = ref27[0];
    var ref28 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CancelFintocPayment()), 1), cancelFintocPayment = ref28[0];
    var ref29 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CancelPayOrderLocal()), 1), cancelPayOrderLocal = ref29[0];
    var ref30 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ConfirmLocalPayment()), 1), confirmLocalPayment = ref30[0];
    var ref31 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DeclarePayOrder()), 1), declarePayOrder = ref31[0];
    var ref32 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CancelBancoEstadoPayment()), 1), cancelBancoEstadoPayment = ref32[0];
    var ref33 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(BancoEstadoPayment()), 1), bancoEstadoPayment = ref33[0];
    var ref34 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(VerifyBancoEstadoJwt()), 1), verifyBancoEstadoJwt = ref34[0];
    var ref35 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,finalSummary/* getFinalSummary */.y)()), 1), prefetchOrder = ref35[0];
    var ref36 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,nextOrders/* getNextOrders */.t)()), 1), getNextOrdersQuery = ref36[0];
    var ref37 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,queries_previousOrders/* previousOrdersQuery */.Q)("pedidos")), 1), previousOrders = ref37[0];
    var ref38 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,getLastOrdersPurchases/* lastPurchasesQuery */.W)()), 1), lastPurchases = ref38[0];
    var ref39 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,currentUserCredits/* currentUserCredits */.B)()), 1), currentUserCreditsQuery = ref39[0];
    var currentUserInfo = (data !== null && data !== void 0 ? data : {}).currentUserInfo;
    var orderMetadata = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.metadata;
    var ref40;
    var chargeDeliveryCost = (ref40 = orderMetadata === null || orderMetadata === void 0 ? void 0 : orderMetadata.chargeDeliveryCost) !== null && ref40 !== void 0 ? ref40 : true;
    var useMekiCredits = orderMetadata === null || orderMetadata === void 0 ? void 0 : orderMetadata.useMekiCredits;
    var insuranceInfo = orderMetadata === null || orderMetadata === void 0 ? void 0 : orderMetadata.insuranceInfo;
    var ordersTotal = orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, order) {
        var orderTotal = order.orderDetails.reduce(function(acc, detail) {
            return acc + detail.quantity * detail.price;
        }, 0);
        if (!chargeDeliveryCost && isAssistantUser) {
            return acc + orderTotal;
        }
        return acc + orderTotal + order.deliveryCost;
    }, 0);
    var paymentMethod = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod;
    var ref41 = !chargeDeliveryCost && isAssistantUser || !deliveryOption ? {
        deliveryCost: 0,
        oldDeliveryCost: 0
    } : (0,getDeliveryCosts/* getDeliveryCosts */.U)(deliveryOption), deliveryCost = ref41.deliveryCost, oldDeliveryCost = ref41.oldDeliveryCost;
    // payAmount (to sent to payOrder) does not consider credits
    var payAmount = (insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.insuranceId) ? ordersTotal - ((insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.totalReimbursement) || 0) : ordersTotal;
    // Only to show on frontend
    var totalFinal = useMekiCredits && !isLocalVendor ? Math.max(ordersTotal - (currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits), 0) : payAmount;
    var needPrescriptions = (orders === null || orders === void 0 ? void 0 : orders.some(function(order) {
        return order.orderDetails.some(function(detail) {
            return [
                "NOT_REQUIRED",
                "SIMPLE",
                "HELD",
                "CHECK"
            ].includes(detail.product.prescriptionType);
        });
    })) || (insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.insuranceId);
    var ordersPayload = (0,react.useMemo)(function() {
        var usedStock = {};
        return ordersByDelivery === null || ordersByDelivery === void 0 ? void 0 : ordersByDelivery.map(function(order) {
            var ref, ref1, ref2;
            var cleanReimbursedProducts = currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.insuranceInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.reimbursedProducts) === null || ref2 === void 0 ? void 0 : ref2.map(function(product) {
                return {
                    sku: +product.sku,
                    observation: product.observation,
                    unitReimbursement: product.unitReimbursement,
                    unitDeductible: product.unitDeductible,
                    unitCopay: product.unitCopay,
                    coverage: product.coverage,
                    quantity: product.quantity
                };
            });
            var _deliveryDate;
            return {
                deliveryDate: (_deliveryDate = order.deliveryDate) !== null && _deliveryDate !== void 0 ? _deliveryDate : "",
                reimbursedProductsInfo: cleanReimbursedProducts,
                details: order.orderDetails.map(function(detail) {
                    var _id;
                    usedStock[detail.product.id] = ((_id = usedStock[detail.product.id]) !== null && _id !== void 0 ? _id : 0) + detail.quantity;
                    var _statusWithoutStock, _price;
                    return {
                        availability: usedStock[detail.product.id] > detail.product.availability.stock ? (_statusWithoutStock = detail.product.availability.statusWithoutStock) !== null && _statusWithoutStock !== void 0 ? _statusWithoutStock : detail.product.availability.status : detail.product.availability.status,
                        price: (_price = detail.price) !== null && _price !== void 0 ? _price : 0,
                        productId: detail.product.id,
                        quantity: detail.quantity
                    };
                })
            };
        }).filter(function(e) {
            return e.details.length > 0;
        });
    }, [
        ordersByDelivery,
        currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.insuranceInfo) === null || ref1 === void 0 ? void 0 : ref1.reimbursedProducts, 
    ]);
    var handleHideError = function() {
        setError(false);
    };
    var handlePayment = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, _data, _payOrderFintoc, fintocToken, orderGroupId, uuid, Fintoc, options, widget, ref4, ref5, ref6, _data1, urlCompraqui, ref7, ref8, _data2, _payOrder, orderGroupId1, uuid1, orderOrGroupUuid, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        9,
                        ,
                        10
                    ]);
                    if (!orderDeliveryOptions) return [
                        2
                    ];
                    if (!((paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "FINTOC")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        payOrderFintoc({
                            variables: {
                                params: {
                                    orderUuid: orderUuid,
                                    orders: ordersPayload,
                                    amount: payAmount,
                                    useCredits: useMekiCredits,
                                    insuranceId: (ref2 = orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref1 = orderMetadata.insuranceInfo) === null || ref1 === void 0 ? void 0 : ref1.insuranceId) !== null && ref2 !== void 0 ? ref2 : null
                                }
                            }
                        }).catch(function(e) {
                            setPayLoading(false);
                            throw e;
                        })
                    ];
                case 1:
                    ref3 = _state.sent(), _data = ref3.data, _payOrderFintoc = _data.payOrderFintoc, fintocToken = _payOrderFintoc.fintocToken, orderGroupId = _payOrderFintoc.orderGroupId, uuid = _payOrderFintoc.uuid;
                    return [
                        4,
                        (0,core/* getFintoc */.Jz)()
                    ];
                case 2:
                    Fintoc = _state.sent();
                    options = {
                        widgetToken: fintocToken,
                        holderType: "individual",
                        product: "payments",
                        publicKey: environment/* FINTOC_TOKEN */.$F,
                        webhookUrl: environment/* GRAPHQL_URI */.r8 + environment/* MEKI_FINTOC_WEEBHOOK */.YU,
                        country: "cl",
                        onEvent: function(event) {
                            utils/* Console.log */.Mn.log("[FINTOC EVENT]: ", event);
                            track("fintoc event ".concat(event), {
                                userId: user === null || user === void 0 ? void 0 : user.id
                            });
                        },
                        onSuccess: function() {
                            utils/* Console.error */.Mn.error("fintoc success");
                            void track("fintoc success", {
                                userId: user === null || user === void 0 ? void 0 : user.id,
                                orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id
                            });
                            setIsFintocSucess(true);
                            setShowCancelButton(false);
                            var interval = setInterval(function() {
                                void prefetchOrder({
                                    variables: {
                                        params: {
                                            status: [
                                                "PAYMENT_CONFIRMED",
                                                "DRAFT"
                                            ],
                                            uuid: orderGroupId !== null && orderGroupId !== void 0 ? orderGroupId : uuid
                                        }
                                    }
                                }).then(function(response) {
                                    if (response.data) {
                                        var ref, ref1;
                                        var status = response.data.ordersByUuid[0].status;
                                        var cancelledByFintoc = (ref = response.data.ordersByUuid[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.cancelledByFintoc;
                                        if (status === "PAYMENT_CONFIRMED") {
                                            clearInterval(interval);
                                            clearInterval(closeFintocIntervalRef.current);
                                            closeFintocIntervalRef.current = null;
                                            var _orderGroupId;
                                            var orderOrGroupUuid = (_orderGroupId = response.data.ordersByUuid[0].orderGroupId) !== null && _orderGroupId !== void 0 ? _orderGroupId : response.data.ordersByUuid[0].uuid;
                                            try {
                                                trackPayment({
                                                    orders: orders,
                                                    orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                                    totalPrice: ordersTotal,
                                                    deliveryPrice: deliveryCost
                                                });
                                            } catch (e) {
                                                utils/* Console.error */.Mn.error("Error tracking payment");
                                                utils/* Console.error */.Mn.error(e);
                                            }
                                            try {
                                                trackFBEvent("track", "Purchase", {
                                                    currency: "CLP",
                                                    value: ordersTotal
                                                }, currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid);
                                            } catch (e1) {
                                                utils/* Console.error */.Mn.error("Error tracking pixel payment");
                                                utils/* Console.error */.Mn.error(e1);
                                            }
                                            void getNextOrdersQuery();
                                            void previousOrders({
                                                variables: {
                                                    params: {
                                                        pageNumber: 0
                                                    }
                                                }
                                            });
                                            void lastPurchases();
                                            void currentUserCreditsQuery();
                                            void router_default().push((0,utils/* getRoute */.Bv)("checkoutPaymentSuccess", {
                                                orderUuid: orderOrGroupUuid
                                            }));
                                            setPayLoading(false);
                                            return;
                                        } else if (status === "DRAFT" && cancelledByFintoc) {
                                            clearInterval(interval);
                                            if (closeFintocIntervalRef.current) {
                                                clearInterval(closeFintocIntervalRef.current);
                                                closeFintocIntervalRef.current = null;
                                            }
                                            setRegistryError(false);
                                            setError(true);
                                            setPayLoading(false);
                                        }
                                    }
                                }).catch(function() {
                                    utils/* Console.log */.Mn.log("ORDER NOT CONRFIRMED BY FINTOC");
                                });
                            }, 2000);
                            setInsuranceId(null);
                            setInsuranceRut("");
                            return;
                        },
                        onExit: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setShowCancelButton(false);
                                        return [
                                            4,
                                            cancelFintocPayment({
                                                variables: {
                                                    params: {
                                                        orderUuid: orderUuid
                                                    }
                                                }
                                            }).catch(function(error) {
                                                utils/* Console.error */.Mn.error("fintoc cancel error");
                                                utils/* Console.error */.Mn.error(error);
                                                void track("fintoc cancel error", {
                                                    orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                                    userId: user === null || user === void 0 ? void 0 : user.id,
                                                    error: error
                                                });
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        utils/* Console.error */.Mn.error("fintoc exit");
                                        void track("fintoc exit", {
                                            orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                            userId: user === null || user === void 0 ? void 0 : user.id
                                        });
                                        return [
                                            4,
                                            refetchOrder()
                                        ];
                                    case 2:
                                        _state.sent();
                                        setRegistryError(false);
                                        setError(true);
                                        setFintocError(true);
                                        setPayLoading(false);
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    };
                    widget = Fintoc.create(options);
                    widget.open();
                    closeFintocIntervalRef.current = setInterval(function() {
                        void prefetchOrder({
                            variables: {
                                params: {
                                    status: [
                                        "DRAFT"
                                    ],
                                    uuid: orderGroupId !== null && orderGroupId !== void 0 ? orderGroupId : uuid
                                }
                            }
                        }).then(function(response) {
                            var ref, ref1;
                            var fintocPaymentIntentId = (ref = response.data.ordersByUuid[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.fintocPaymentIntentId;
                            if (!fintocPaymentIntentId) {
                                clearInterval(closeFintocIntervalRef.current);
                                closeFintocIntervalRef.current = null;
                                setRegistryError(false);
                                setError(true);
                                widget.destroy();
                            }
                        }).catch(function() {
                            utils/* Console.log */.Mn.log("ORDER NOT CANCELLED BY USER");
                        });
                    }, 2000);
                    return [
                        2
                    ];
                case 3:
                    if (!((paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === "BANCO_ESTADO")) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        bancoEstadoPayment({
                            variables: {
                                params: {
                                    orderUuid: orderUuid,
                                    orders: ordersPayload,
                                    amount: payAmount,
                                    useCredits: useMekiCredits,
                                    insuranceId: (ref5 = orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref4 = orderMetadata.insuranceInfo) === null || ref4 === void 0 ? void 0 : ref4.insuranceId) !== null && ref5 !== void 0 ? ref5 : null
                                }
                            }
                        }).catch(function(e) {
                            setPayLoading(false);
                            throw e;
                        })
                    ];
                case 4:
                    ref6 = _state.sent(), _data1 = ref6.data, urlCompraqui = _data1.bancoEstadoPayment.urlCompraqui;
                    void router_default().push(urlCompraqui);
                    return [
                        4,
                        refetchOrder()
                    ];
                case 5:
                    _state.sent();
                    setInsuranceId(null);
                    setInsuranceRut("");
                    return [
                        2,
                        ""
                    ];
                case 6:
                    return [
                        4,
                        payOrder({
                            variables: {
                                params: {
                                    orderUuid: orderUuid,
                                    orders: ordersPayload,
                                    amount: payAmount,
                                    useCredits: useMekiCredits,
                                    chargeDeliveryCost: chargeDeliveryCost !== null && chargeDeliveryCost !== void 0 ? chargeDeliveryCost : true,
                                    insuranceId: (ref7 = orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref = orderMetadata.insuranceInfo) === null || ref === void 0 ? void 0 : ref.insuranceId) !== null && ref7 !== void 0 ? ref7 : null
                                }
                            }
                        }).catch(function(e) {
                            var err = e;
                            if ((0,errors/* isApolloError */.M)(err)) {
                                var isOrderWithNotAllowedProducts = err.graphQLErrors.some(function(error) {
                                    return error.message == "3005: Not all products are valid";
                                });
                                if (isOrderWithNotAllowedProducts) setNotAllowedItemsError(isOrderWithNotAllowedProducts);
                                if (err.message && err.message == "Insurance info does not match") {
                                    setInsuranceValidationError(true);
                                }
                            }
                            throw err;
                        })
                    ];
                case 7:
                    ref8 = _state.sent(), _data2 = ref8.data, _payOrder = _data2.payOrder, orderGroupId1 = _payOrder.orderGroupId, uuid1 = _payOrder.uuid;
                    try {
                        trackPayment({
                            orders: orders,
                            orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                            totalPrice: ordersTotal,
                            deliveryPrice: deliveryCost
                        });
                    } catch (e1) {
                        utils/* Console.error */.Mn.error("Error tracking payment");
                        utils/* Console.error */.Mn.error(e1);
                    }
                    try {
                        trackFBEvent("track", "Purchase", {
                            currency: "CLP",
                            value: ordersTotal
                        }, currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid);
                    } catch (e2) {
                        utils/* Console.error */.Mn.error("Error tracking pixel payment");
                        utils/* Console.error */.Mn.error(e2);
                    }
                    return [
                        4,
                        prefetchOrder({
                            variables: {
                                params: {
                                    status: [
                                        "PAYMENT_CONFIRMED"
                                    ],
                                    uuid: orderGroupId1 !== null && orderGroupId1 !== void 0 ? orderGroupId1 : uuid1
                                }
                            }
                        }).finally(function() {
                            setPayLoading(false);
                        })
                    ];
                case 8:
                    _state.sent();
                    orderOrGroupUuid = orderGroupId1 !== null && orderGroupId1 !== void 0 ? orderGroupId1 : uuid1;
                    void router_default().push((0,utils/* getRoute */.Bv)("checkoutPaymentSuccess", {
                        orderUuid: orderOrGroupUuid
                    }));
                    return [
                        2,
                        ""
                    ];
                case 9:
                    e = _state.sent();
                    setPayLoading(false);
                    utils/* Console.error */.Mn.error("error", e);
                    setRegistryError(false);
                    setError(true);
                    return [
                        3,
                        10
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    }), [
        orderDeliveryOptions,
        paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type,
        payOrder,
        orderUuid,
        ordersPayload,
        payAmount,
        useMekiCredits,
        chargeDeliveryCost,
        orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref2 = orderMetadata.insuranceInfo) === null || ref2 === void 0 ? void 0 : ref2.insuranceId,
        prefetchOrder,
        payOrderFintoc,
        track,
        user === null || user === void 0 ? void 0 : user.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid,
        setInsuranceId,
        setInsuranceRut,
        getNextOrdersQuery,
        previousOrders,
        lastPurchases,
        currentUserCreditsQuery,
        trackPayment,
        orders,
        ordersTotal,
        deliveryCost,
        trackFBEvent,
        cancelFintocPayment,
        refetchOrder,
        bancoEstadoPayment, 
    ]);
    var handlePaymentAction = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!paymentMethod) {
                        return [
                            2
                        ];
                    }
                    void track("order attempt", {
                        paymentOptionSelected: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type,
                        payment_method_type: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type,
                        userId: user === null || user === void 0 ? void 0 : user.id,
                        orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                        chargeDeliveryCost: chargeDeliveryCost
                    });
                    return [
                        4,
                        handlePayment()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        paymentMethod,
        track,
        user === null || user === void 0 ? void 0 : user.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        chargeDeliveryCost,
        handlePayment, 
    ]);
    var handleCancel = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod.id) === -6)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        cancelBancoEstadoPayment({
                            variables: {
                                params: {
                                    orderUuid: orderUuid
                                }
                            }
                        }).catch(function(error) {
                            utils/* Console.error */.Mn.error("Error cancel banco estado payment");
                            utils/* Console.error */.Mn.error(error);
                            void track("banco estado cancel error", {
                                orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                userId: user === null || user === void 0 ? void 0 : user.id,
                                error: error
                            });
                            return;
                        })
                    ];
                case 1:
                    _state.sent();
                    utils/* Console.error */.Mn.error("banco estado cancel");
                    void track("banco estado cancel", {
                        orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                        userId: user === null || user === void 0 ? void 0 : user.id
                    });
                    return [
                        4,
                        refetchOrder()
                    ];
                case 2:
                    _state.sent();
                    setError(false);
                    setPayLoading(false);
                    return [
                        2
                    ];
                case 3:
                    return [
                        4,
                        cancelFintocPayment({
                            variables: {
                                params: {
                                    orderUuid: orderUuid
                                }
                            }
                        }).catch(function(error) {
                            utils/* Console.error */.Mn.error("Error cancel fintoc payment");
                            utils/* Console.error */.Mn.error(error);
                            void track("fintoc cancel error", {
                                orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                userId: user === null || user === void 0 ? void 0 : user.id,
                                error: error
                            });
                        })
                    ];
                case 4:
                    _state.sent();
                    utils/* Console.error */.Mn.error("fintoc cancel");
                    void track("fintoc cancel", {
                        orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                        userId: user === null || user === void 0 ? void 0 : user.id
                    });
                    return [
                        4,
                        refetchOrder()
                    ];
                case 5:
                    _state.sent();
                    setError(false);
                    setPayLoading(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        currentOrder === null || currentOrder === void 0 ? void 0 : (ref3 = currentOrder.paymentMethod) === null || ref3 === void 0 ? void 0 : ref3.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        cancelFintocPayment,
        orderUuid,
        track,
        user === null || user === void 0 ? void 0 : user.id,
        refetchOrder,
        cancelBancoEstadoPayment, 
    ]);
    var handleConfirmLocalPayment = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, _data, _confirmLocalPayment, orderGroupId, uuid, orderOrGroupUuid;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        confirmLocalPayment({
                            variables: {
                                params: {
                                    orderUuid: orderUuid
                                }
                            }
                        }).catch(function(e) {
                            setPayLoading(false);
                            throw e;
                        })
                    ];
                case 1:
                    ref = _state.sent(), _data = ref.data, _confirmLocalPayment = _data.confirmLocalPayment, orderGroupId = _confirmLocalPayment.orderGroupId, uuid = _confirmLocalPayment.uuid;
                    orderOrGroupUuid = orderGroupId !== null && orderGroupId !== void 0 ? orderGroupId : uuid;
                    try {
                        trackPayment({
                            orders: orders,
                            orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                            totalPrice: ordersTotal,
                            deliveryPrice: deliveryCost
                        });
                    } catch (e) {
                        setPayLoading(false);
                        utils/* Console.error */.Mn.error("Error tracking payment");
                        utils/* Console.error */.Mn.error(e);
                    }
                    try {
                        trackFBEvent("track", "Purchase", {
                            currency: "CLP",
                            value: ordersTotal
                        }, currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid);
                    } catch (e1) {
                        setPayLoading(false);
                        utils/* Console.error */.Mn.error("Error tracking pixel payment");
                        utils/* Console.error */.Mn.error(e1);
                    }
                    void getNextOrdersQuery();
                    void previousOrders({
                        variables: {
                            params: {
                                pageNumber: 0
                            }
                        }
                    });
                    void lastPurchases();
                    void currentUserCreditsQuery();
                    setPayLoading(false);
                    void router_default().push((0,utils/* getRoute */.Bv)("checkoutPaymentSuccess", {
                        orderUuid: orderOrGroupUuid
                    }));
                    return [
                        2
                    ];
            }
        });
    }), [
        confirmLocalPayment,
        currentUserCreditsQuery,
        getNextOrdersQuery,
        lastPurchases,
        orders,
        orderUuid,
        previousOrders,
        trackPayment,
        trackFBEvent,
        ordersTotal,
        currentOrder,
        deliveryCost, 
    ]);
    var ref42 = (0,localPaymentOptionsStore/* useLocalPaymentOptionsActions */.e)(), cleanValuesLocal = ref42.cleanValues;
    var handleCancelPayOrderLocal = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    void cleanValuesLocal();
                    return [
                        4,
                        cancelPayOrderLocal({
                            variables: {
                                params: {
                                    orderUuid: orderUuid
                                }
                            }
                        }).catch(function(e) {
                            void trackIssue("[CANCEL_PAY_ORDER_LOCAL]: Error cancelling pay order local", {
                                orderUuid: orderUuid
                            });
                            throw e;
                        }).finally(function() {
                            void router_default().push((0,utils/* getRoute */.Bv)("home"));
                        })
                    ];
                case 1:
                    _state.sent();
                    void router_default().push((0,utils/* getRoute */.Bv)("home"));
                    return [
                        2
                    ];
            }
        });
    }), [
        cancelPayOrderLocal,
        cleanValuesLocal,
        orderUuid,
        trackIssue
    ]);
    var handleAssistantPaymentAction = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, paymentOption, ref2, ref3, ref4, ref5, _data, _declarePayOrder, orderGroupId, uuid, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    paymentOption = currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.assistantVendor) === null || ref1 === void 0 ? void 0 : ref1.paymentMethod;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    if (!paymentOption && !useMekiCredits) {
                        setPayLoading(false);
                        setErrorMessage("No se ha seleccionado un m\xe9todo de pago");
                        return [
                            2
                        ];
                    }
                    if (!(paymentOption === "CARD")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handlePaymentAction()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    return [
                        4,
                        declarePayOrder({
                            variables: {
                                params: {
                                    orderUuid: orderUuid,
                                    orders: ordersPayload,
                                    amount: payAmount,
                                    sendEmail: (ref4 = currentOrder === null || currentOrder === void 0 ? void 0 : (ref2 = currentOrder.metadata) === null || ref2 === void 0 ? void 0 : ref2.sendEmail) !== null && ref4 !== void 0 ? ref4 : true,
                                    useCredits: useMekiCredits,
                                    paymentType: paymentOption,
                                    chargeDeliveryCost: chargeDeliveryCost,
                                    insuranceId: orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref3 = orderMetadata.insuranceInfo) === null || ref3 === void 0 ? void 0 : ref3.insuranceId
                                }
                            }
                        })
                    ];
                case 4:
                    ref5 = _state.sent(), _data = ref5.data, _declarePayOrder = _data.declarePayOrder, orderGroupId = _declarePayOrder.orderGroupId, uuid = _declarePayOrder.uuid;
                    return [
                        4,
                        prefetchOrder({
                            variables: {
                                params: {
                                    status: [
                                        "PAYMENT_CONFIRMED"
                                    ],
                                    uuid: uuid
                                }
                            }
                        }).finally(function() {
                            setPayLoading(false);
                        })
                    ];
                case 5:
                    _state.sent();
                    void router_default().push((0,utils/* getRoute */.Bv)("checkoutPaymentSuccess", {
                        orderUuid: orderGroupId !== null && orderGroupId !== void 0 ? orderGroupId : uuid
                    }));
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    setError(true);
                    throw e;
                case 7:
                    return [
                        2
                    ];
            }
        });
    }), [
        currentOrder === null || currentOrder === void 0 ? void 0 : (ref4 = currentOrder.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.assistantVendor) === null || ref5 === void 0 ? void 0 : ref5.paymentMethod,
        currentOrder === null || currentOrder === void 0 ? void 0 : (ref6 = currentOrder.metadata) === null || ref6 === void 0 ? void 0 : ref6.sendEmail,
        useMekiCredits,
        declarePayOrder,
        orderUuid,
        ordersPayload,
        payAmount,
        chargeDeliveryCost,
        prefetchOrder,
        handlePaymentAction,
        orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref7 = orderMetadata.insuranceInfo) === null || ref7 === void 0 ? void 0 : ref7.insuranceId, 
    ]);
    var prescriptionComponentRef = (0,react.useRef)(null);
    var scrollToDiv = function() {
        if (prescriptionComponentRef.current) {
            prescriptionComponentRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    };
    var prescriptionsValid = function() {
        var hasInsurance = Boolean(insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.claimId);
        var uploadedImages = (pendingPrescriptions === null || pendingPrescriptions === void 0 ? void 0 : pendingPrescriptions.length) > 0;
        if (hasInsurance && !uploadedImages && !associatedPrescriptions.length) return false;
        if (!requirePrescriptions) return true;
        if (!requirePrescriptionUpload) return true;
        return (pendingPrescriptions === null || pendingPrescriptions === void 0 ? void 0 : pendingPrescriptions.length) > 0 || associatedPrescriptions.length > 0;
    };
    var handlePay = function() {
        setPayLoading(true);
        if (!prescriptionsValid()) {
            scrollToDiv();
            setPrescriptionsError(true);
            setPayLoading(false);
            return;
        }
        if (isLocalVendor) {
            void handleConfirmLocalPayment();
            return;
        }
        if (isAssistantUser) {
            void handleAssistantPaymentAction();
            return;
        }
        void handlePaymentAction();
        return;
    };
    var ref43;
    var deliveryDatesAndProductsAmount = (ref43 = ordersPayload === null || ordersPayload === void 0 ? void 0 : ordersPayload.map(function(order) {
        return {
            date: order.deliveryDate,
            productAmount: order.details.length
        };
    })) !== null && ref43 !== void 0 ? ref43 : null;
    var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    (0,react.useEffect)(function() {
        if ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status) === "PAYMENT_VALIDATION" && !isLocalVendor && !isAssistantUser) {
            setPayLoading(true);
            setIsFintocSucess(true);
            setShowCancelButton(true);
        }
        if ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status) === "PAYMENT_VALIDATION" && isLocalVendor) {
            setPayLoading(false);
        }
        if ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status) === "PAYMENT_VALIDATION" && isAssistantUser) {
            setPayLoading(false);
            setShowCancelButton(true);
        }
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status,
        isAssistantUser,
        isLocalVendor
    ]);
    (0,react.useEffect)(function() {
        var query = (router_default()).query;
        var jwt = query.jwt;
        if (jwt) {
            setPayLoading(true);
            void verifyBancoEstadoJwt({
                variables: {
                    params: {
                        jwt: jwt
                    }
                }
            }).then(function(response) {
                var ref;
                var ref1 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.verifyBancoEstadoJwt, orderUuid = ref1.uuid, orders = ref1.orders, totalPrice = ref1.totalPrice, deliveryPrice = ref1.deliveryPrice;
                if (orderUuid) {
                    void track("banco estado success", {
                        userId: user === null || user === void 0 ? void 0 : user.id,
                        orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id
                    });
                    try {
                        trackPayment({
                            orders: orders,
                            orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                            totalPrice: totalPrice,
                            deliveryPrice: deliveryPrice
                        });
                    } catch (e) {
                        utils/* Console.error */.Mn.error("Error tracking payment");
                        utils/* Console.error */.Mn.error(e);
                    }
                    try {
                        trackFBEvent("track", "Purchase", {
                            currency: "CLP",
                            value: ordersTotal
                        }, currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid);
                    } catch (e1) {
                        utils/* Console.error */.Mn.error("Error tracking pixel payment");
                        utils/* Console.error */.Mn.error(e1);
                    }
                    void getNextOrdersQuery();
                    void previousOrders({
                        variables: {
                            params: {
                                pageNumber: 0
                            }
                        }
                    });
                    void lastPurchases();
                    void currentUserCreditsQuery();
                    void nextRouter.replace({
                        pathname: "/inicio",
                        query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nextRouter.query), {
                            jwt: undefined,
                            pathname: "/checkout/pago-exitoso/[orderUuid]",
                            orderUuid: orderUuid
                        }))
                    }, {
                        pathname: "/checkout/pago-exitoso/".concat(orderUuid),
                        query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (router_default()).query), {
                            jwt: undefined
                        }))
                    });
                    return;
                }
                void nextRouter.replace({
                    pathname: "/inicio",
                    query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nextRouter.query), {
                        jwt: undefined,
                        pathname: "/checkout/confirmar-pago"
                    }))
                }, {
                    pathname: "/checkout/confirmar-pago",
                    query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (router_default()).query), {
                        jwt: undefined
                    }))
                });
                setPayLoading(false);
                setRegistryError(false);
                setError(true);
            }).catch(function() {
                void nextRouter.replace({
                    pathname: "/inicio",
                    query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nextRouter.query), {
                        jwt: undefined,
                        pathname: "/checkout/confirmar-pago"
                    }))
                }, {
                    pathname: "/checkout/confirmar-pago",
                    query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (router_default()).query), {
                        jwt: undefined
                    }))
                });
                setPayLoading(false);
                setRegistryError(false);
                setError(true);
            });
        }
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid,
        currentUserCreditsQuery,
        getNextOrdersQuery,
        lastPurchases,
        nextRouter,
        ordersTotal,
        previousOrders,
        track,
        trackFBEvent,
        trackPayment,
        user === null || user === void 0 ? void 0 : user.id,
        verifyBancoEstadoJwt, 
    ]);
    (0,react.useEffect)(function() {
        setLoadingCurrentOrder(loadingCurrentOrder);
    }, [
        loadingCurrentOrder,
        setLoadingCurrentOrder
    ]);
    var errorType = (0,react.useMemo)(function() {
        if (fintocError) return ErrorModal/* ErrorModalTypes.FINTOC */.C.FINTOC;
        if (registryError) return ErrorModal/* ErrorModalTypes.REGISTRY */.C.REGISTRY;
        if (notAllowedItemsError) return ErrorModal/* ErrorModalTypes.NOT_ALLOWED_ITEMS */.C.NOT_ALLOWED_ITEMS;
        if (insuranceValidationError) return ErrorModal/* ErrorModalTypes.INVALID_INSURANCE */.C.INVALID_INSURANCE;
        if (error) return ErrorModal/* ErrorModalTypes.DEFAULT */.C.DEFAULT;
        return ErrorModal/* ErrorModalTypes.NONE */.C.NONE;
    }, [
        fintocError,
        registryError,
        notAllowedItemsError,
        insuranceValidationError,
        error, 
    ]);
    (0,react.useEffect)(function() {
        var separateOrder = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, cleanReimbursedProducts, ref3, response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cleanReimbursedProducts = currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.insuranceInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.reimbursedProducts) === null || ref2 === void 0 ? void 0 : ref2.filter(function(product) {
                                return product.coverage;
                            }).map(function(product) {
                                return {
                                    sku: +product.sku,
                                    observation: product.observation,
                                    unitReimbursement: product.unitReimbursement,
                                    unitDeductible: product.unitDeductible,
                                    unitCopay: product.unitCopay,
                                    quantity: product.quantity,
                                    coverage: product.coverage
                                };
                            });
                            if (!((ordersByDelivery === null || ordersByDelivery === void 0 ? void 0 : ordersByDelivery.length) && (cleanReimbursedProducts === null || cleanReimbursedProducts === void 0 ? void 0 : cleanReimbursedProducts.length))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                separateDetailsByInsurance({
                                    variables: {
                                        params: {
                                            orders: ordersByDelivery,
                                            reimbursedProducts: cleanReimbursedProducts
                                        }
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            setOrders((ref3 = response.data) === null || ref3 === void 0 ? void 0 : ref3.separateOrderDetailsByInsurance);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            setOrders(ordersByDelivery);
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function separateOrder() {
                return _ref.apply(this, arguments);
            };
        }();
        void separateOrder();
    }, [
        ordersByDelivery,
        currentOrder,
        separateDetailsByInsurance
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* ContentContainer */.E, {
                bottomNavigation: main/* isMobile */.tq,
                children: payLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingScreen */.a_, {
                    redirectMessage: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "FINTOC" || (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "BANCO_ESTADO",
                    isFintocSuccess: isFintocSuccess,
                    showCancelButton: showCancelButton,
                    handleCancel: handleCancel,
                    isLocalVendor: isLocalVendor,
                    isInsurance: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "INSURANCE"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader/* Header */.h, {
                            title: "Confirmaci\xf3n de compra",
                            backIcon: !isLocalVendor,
                            backFunction: function() {
                                if (requirePrescriptions) {
                                    void modalRouter.replace((0,utils/* getRoute */.Bv)("checkoutPrescriptions"));
                                    return;
                                }
                                void modalRouter.replace((0,utils/* getRoute */.Bv)("checkoutPaymentMethod"));
                            },
                            hideBorder: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContent/* ModalContent */.h, {
                            isSafari: environment/* isSafari */.G6,
                            removePadding: true,
                            desktopHeight: "calc(100vh - 150px)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Resume, {
                                    totalCost: ordersTotal,
                                    shippingCost: deliveryCost,
                                    oldShippingCost: oldDeliveryCost,
                                    totalFinal: totalFinal,
                                    handlePay: handlePay,
                                    paymentMethod: paymentMethod,
                                    handleCancelPayOrderLocal: handleCancelPayOrderLocal
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddPadding, {
                                    children: [
                                        isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: (currentOrder === null || currentOrder === void 0 ? void 0 : (ref8 = currentOrder.metadata) === null || ref8 === void 0 ? void 0 : ref8.sendEmail) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmailNotificationTypography, {
                                                children: [
                                                    "El cliente recibir\xe1 un correo",
                                                    " "
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailNotificationTypography, {
                                                children: "El cliente no recibir\xe1 un correo"
                                            })
                                        }),
                                        isAssistantUser || isLocalVendor && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: errorMessage.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotificationTypography, {
                                                children: errorMessage
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsList/* ProductsList */.R, {
                                            isDelivery: (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.deliveryType) === "DELIVERY",
                                            orders: orders,
                                            insuranceInfo: insuranceInfo
                                        }),
                                        !isLocalVendor && needPrescriptions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PendingPrescriptions, {
                                                    title: "Recetas",
                                                    hasInsurance: Boolean(insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.claimId),
                                                    error: prescriptionsError,
                                                    setError: setPrescriptionsError
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    ref: prescriptionComponentRef
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryDetails, {
                                            deliveryDatesAndProductsAmount: deliveryDatesAndProductsAmount,
                                            address: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.address,
                                            deliveryType: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.deliveryType
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodDetails/* PaymentMethodDetails */.I, {
                                            paymentMethod: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod,
                                            creditsUsed: useMekiCredits ? currencyFormatter.format(Math.min(currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits, ordersTotal)) : "$0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PayButtonContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PayButton, {
                                                    handleNext: handlePay,
                                                    text: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "ONE_CLICK" || isLocalVendor || isAssistantUser || (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "MEKI_CREDIT" || (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "INSURANCE" ? "Confirmar compra" : "Ir a pagar"
                                                }),
                                                isLocalVendor && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCancelButton, {
                                                    onClick: handleCancelPayOrderLocal,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalTypographyButton, {
                                                        children: "Cancelar pago"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorModal/* ErrorModal */.k, {
                handleHideError: handleHideError,
                uuid: orderUuid,
                errorType: errorType,
                refetchOrder: refetchOrder
            })
        ]
    });
}


/***/ }),

/***/ 23793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O3": function() { return /* binding */ DivisionLine; },
/* harmony export */   "aL": function() { return /* binding */ SubTitleTypography; },
/* harmony export */   "dP": function() { return /* binding */ TitleTypography; },
/* harmony export */   "of": function() { return /* binding */ RootDiv; },
/* harmony export */   "yY": function() { return /* binding */ PaymentMethodItem; }
/* harmony export */ });
/* unused harmony exports InformationTypography, InsuranceSubtitleContainer, InsuranceColumnContainer, IconContainer */
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29630);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);


var RootDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "white",
    border: "1px solid #EAEAEA",
    borderRadius: "10px"
});
var TitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontSize: "16px",
    fontWeight: 600,
    color: "#414046",
    marginBottom: "12px",
    textAlign: "left",
    marginLeft: "12px",
    marginTop: "12px"
});
var SubTitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontSize: "14px",
    fontWeight: 500,
    color: "#414046",
    textAlign: "left",
    marginLeft: "12px",
    marginTop: "10px",
    marginBottom: "10px"
});
var DivisionLine = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    height: "1px",
    backgroundColor: "#EAEAEA",
    width: "100%"
});
var InformationTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontSize: "12px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: "18px",
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "#757475",
    marginLeft: "12px",
    marginTop: "-8px",
    marginBottom: "10px"
});
var InsuranceSubtitleContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 12px 0 12px"
});
var InsuranceColumnContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start"
});
var IconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
});
var PaymentMethodItem = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: "10px",
    cursor: "default",
    opacity: 1,
    padding: "12px 15px",
    gap: 0
});



/***/ }),

/***/ 39566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ Item; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/screens/product/utils/extractExtraInfo.tsx
var extractExtraInfo = __webpack_require__(73724);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentSuccess/styles/ItemDetails.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    minWidth: "100px",
    paddingBottom: 0,
    padding: "0 10px 0px 16px"
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    fontWeight: 500,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
var DetailsTextTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    letterSpacing: "0.4px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    marginTop: "3px",
    color: "#757475",
    span: {
        color: "#414046"
    }
});
var DetailsPriceDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row"
});
var DetailsPriceTypographyBold = (0,styled/* default */.Z)(Typography/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "type";
    }
})(function(param) {
    var type = param.type;
    return {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: type == "normal" ? "#414046" : type == "insurance" ? "#731EFF" : "#CBCBCB",
        textDecoration: type == "strikethrough" ? "line-through" : "none"
    };
});
var DetailsPriceTypographyLight = (0,styled/* default */.Z)(Typography/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "type";
    }
})(function(param) {
    var type = param.type;
    return {
        fontFamily: "Poppins",
        fontWeight: type == "insurance" ? 500 : 300,
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: type == "normal" ? "#414046" : type == "insurance" ? "#731EFF" : "#CBCBCB",
        textDecoration: type == "strikethrough" ? "line-through" : "none"
    };
});
var ColumnDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});


// EXTERNAL MODULE: ./src/screens/checkout/utils/discountTypeBanner.tsx
var discountTypeBanner = __webpack_require__(54773);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentSuccess/components/ItemDetails.tsx





var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J();
function CartProductDetails(props) {
    var ref, ref1, ref2, ref3, ref4;
    var product = props.product, price = props.price, quantity = props.quantity, unitCopay = props.unitCopay, type = props.type, listPrice = props.listPrice;
    var hasInsurance = unitCopay >= 0;
    var hasDiscount = (product === null || product === void 0 ? void 0 : (ref = product.discount) === null || ref === void 0 ? void 0 : ref.price) > 0;
    var hasManualPrice = price !== (product === null || product === void 0 ? void 0 : product.price) && price !== (product === null || product === void 0 ? void 0 : (ref1 = product.discount) === null || ref1 === void 0 ? void 0 : ref1.price);
    var isMekiPriceDifferent = listPrice && listPrice > 0 ? listPrice : hasDiscount && !hasManualPrice || hasInsurance;
    var currentPrice = hasInsurance ? unitCopay : listPrice && listPrice > 0 ? price : product === null || product === void 0 ? void 0 : (ref2 = product.discount) === null || ref2 === void 0 ? void 0 : ref2.price;
    var realMekiPrice = listPrice && listPrice > 0 ? listPrice : hasInsurance || hasManualPrice || !hasDiscount ? price : Number(product === null || product === void 0 ? void 0 : (ref3 = product.discount) === null || ref3 === void 0 ? void 0 : ref3.listPrice);
    var discountType = type !== null && type !== void 0 ? type : product === null || product === void 0 ? void 0 : (ref4 = product.discount) === null || ref4 === void 0 ? void 0 : ref4.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                variant: "subtitle2",
                children: product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                color: "textSecondary",
                variant: "body2",
                children: (0,extractExtraInfo/* extractExtraInfo */.UD)(product)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                color: "textPrimary",
                variant: "subtitle2",
                children: product.laboratory
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsPriceTypographyBold, {
                                type: isMekiPriceDifferent ? "strikethrough" : "normal",
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: quantity > 1 && "".concat(currFormat.format(realMekiPrice * quantity), "・")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceTypographyLight, {
                                type: isMekiPriceDifferent ? "strikethrough" : "normal",
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: [
                                    "".concat(currFormat.format(realMekiPrice)),
                                    "/un"
                                ]
                            })
                        ]
                    }),
                    isMekiPriceDifferent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsPriceTypographyBold, {
                                type: "insurance",
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: quantity > 1 && "".concat(currFormat.format(currentPrice * quantity), "・")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceTypographyLight, {
                                type: "insurance",
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: [
                                    "".concat(currFormat.format(currentPrice)),
                                    "/un"
                                ]
                            })
                        ]
                    }),
                    discountType && discountType != "REGULAR" && Object.values(discountTypeBanner/* DISCOUNT_TYPES */.v5).includes(discountType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(discountTypeBanner/* DiscountTypeContainer */._D, {
                        children: (0,discountTypeBanner/* discountText */.LT)(discountType)
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentSuccess/styles/Item.styles.ts



var Item_styles_RootDiv = (0,styled/* default */.Z)("div")({
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "row",
    padding: "12px",
    borderBottom: "1px solid #EAEAEA",
    alignItems: "center",
    height: "fit-content",
    position: "relative",
    ":last-child": {
        borderRadius: "0 0 10px 10px",
        borderBottom: "none"
    }
});
var ProductQuantity = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "0 20px"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(600), {
        padding: "0 5px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(500), {
        padding: "0 2px"
    }), _obj;
});
var VerticalLine = (0,styled/* default */.Z)("hr")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: "100%",
        margin: 0,
        border: "1px solid #EAEAEA",
        position: "absolute",
        marginLeft: "60px"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(600), {
        marginLeft: "30px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(500), {
        marginLeft: "20px"
    }), _obj;
});
var ImgDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        maxWidth: "100px",
        minWidth: "100px",
        justifyContent: "center",
        marginLeft: "35px",
        height: "inherit",
        aspectRatio: "1",
        alignItems: "center"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(600), {
        maxWidth: "80px",
        minWidth: "80px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(500), {
        maxWidth: "60px",
        minWidth: "60px"
    }), _obj;
});
var ImgProduct = (0,styled/* default */.Z)("img")({
    maxWidth: "100%",
    display: "block",
    maxHeight: "90%"
});
var SkeletonQuantity = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "20px",
    height: "20px",
    marginLeft: "10px",
    marginRight: "50px"
});
var SkeletonImg = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "5rem",
    height: "5rem"
});
var SkeletonText = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "130px",
    height: "80px",
    marginLeft: "16px"
});


// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentSuccess/components/Item.tsx




function Item(props) {
    var product = props.product, price = props.price, quantity = props.quantity, insurance = props.insurance, loading = props.loading, type = props.type, listPrice = props.listPrice;
    var ref = (0,react.useState)(product.imagesUrl[0]), imageUrl = ref[0], setImageUrl = ref[1];
    var handleImageError = function() {
        setImageUrl("/assets/images/default.webp");
    };
    (0,react.useEffect)(function() {
        setImageUrl(product.imagesUrl[0]);
    }, [
        product.imagesUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item_styles_RootDiv, {
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonQuantity, {
                variant: "rectangular"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductQuantity, {
                children: quantity
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonImg, {
                variant: "rectangular"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgProduct, {
                    src: imageUrl,
                    onError: handleImageError
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLine, {}),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText, {
                variant: "rectangular"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductDetails, {
                product: product,
                price: price,
                unitReimbursement: insurance === null || insurance === void 0 ? void 0 : insurance.unitReimbursement,
                unitDeductible: insurance === null || insurance === void 0 ? void 0 : insurance.unitDeductible,
                unitCopay: insurance === null || insurance === void 0 ? void 0 : insurance.unitCopay,
                quantity: quantity,
                type: type,
                listPrice: listPrice
            })
        ]
    });
}


/***/ }),

/***/ 54773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LT": function() { return /* binding */ discountText; },
/* harmony export */   "_D": function() { return /* binding */ DiscountTypeContainer; },
/* harmony export */   "v5": function() { return /* binding */ DISCOUNT_TYPES; }
/* harmony export */ });
/* unused harmony export DiscountTypography */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87843);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);



var DiscountTypeContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")(function() {
    return {
        backgroundColor: "#F2EFF5",
        marginTop: "5px",
        padding: "1px 6px",
        width: "fit-content"
    };
});
var DiscountTypography = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "bold";
    }
})(function(param) {
    var bold = param.bold;
    return {
        color: "#5D5FEF",
        fontFamily: "Poppins",
        fontWeight: bold ? 500 : 400,
        fontSize: "12px",
        lineHeight: "19px",
        letterSpacing: "2%"
    };
});
var DISCOUNT_TYPES = {
    EXPIRATION: "EXPIRATION",
    MEKI: "MEKI"
};
var discountText = function(type) {
    switch(type){
        case DISCOUNT_TYPES.EXPIRATION:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DiscountTypography, {
                bold: false,
                children: "Descuento por vencimiento entre 2 y 6 meses"
            });
        default:
            return null;
    }
};



/***/ }),

/***/ 4999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getDeliveryCosts; }
/* harmony export */ });
function getDeliveryCosts(item) {
    var usedDeliveryCoupons = item.orders.filter(function(order) {
        return order.deliveryCoupon;
    }).length;
    var totalCost = item.orders[0].totalCost;
    var productsCost = totalCost - item.deliveryCost;
    var oldDeliveryCost = item.orders.length === 2 ? usedDeliveryCoupons === 2 ? 3490 + 990 : usedDeliveryCoupons === 1 ? productsCost < 35000 ? 3490 + 990 : productsCost < 70000 ? 990 : null : null : item.orders.length === 1 ? usedDeliveryCoupons === 1 ? 3490 : null : null;
    return {
        oldDeliveryCost: oldDeliveryCost,
        deliveryCost: item.deliveryCost
    };
}


/***/ })

}]);